import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FaDownload } from "react-icons/fa";

import PlanilhaSugestoesEscolasActions from "@/store/ducks/planilhas/sugestoes-escolas";
import { Button } from "@/components/Common";

export default function DownloadPlanilhaSugestoesEscolas({
  params = {},
  ...rest
}) {
  const dispatch = useDispatch();
  const [href, setHref] = useState(null);

  const { data, loading } = useSelector(state => state.planilhaSugestoesEscolas);

  function handleRequestPlanilha() {
    dispatch(PlanilhaSugestoesEscolasActions.request(params));
  }

  function renderButton() {
    if (!href) {
      return (
        <Button
          title="Solicitar geração de planilha de sugestões de escolas"
          onClick={handleRequestPlanilha}
          loading={loading}
          {...rest}
        >
          <FaDownload size={13} /> Solicitar geração de planilha
        </Button>
      );
    }

    return (
      <Button
        externalLink
        title="Fazer download da planilha de sugestões de escolas"
        to={href}
        loading={loading}
        {...rest}
      >
        <FaDownload size={13} /> Download da planilha
      </Button>
    );
  }

  const setHrefCB = useCallback(() => {
    if (!data) return setHref(null);
    const { url } = data;
    setHref(url);
  }, [data, setHref]);

  const resetDataCB = useCallback(() => {
    dispatch(PlanilhaSugestoesEscolasActions.reset());
  }, [params, dispatch]);

  useEffect(() => {
    setHrefCB();
  }, [setHrefCB]);

  useEffect(() => {
    resetDataCB();
  }, [resetDataCB]);

  return <>{renderButton()}</>;
}
